import {
  CaretDownFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { NavBar } from '../../compnents/nav/NavBar'
import { TenantQueryParams } from '../../services/tenant'
import { ThemeContext } from '../../theme/ThemeContext'
import { columns } from './ReplaceMakeSupplierColumns'
import { AddReplaceMakeSupplierModel } from './AddReplaceMakeSupplierModel'
import styles from './ReplaceMakeSupplier.module.css'
import {
  getReplaceMakeSupplierList,
  isOpenReplaceMakeSupplier,
} from './ReplaceMakeSupplierSclice'
import { useHistory } from 'react-router-dom'
interface ReplaceMakeSupplierProps {
  state: string
}
// 代煎饮片厂
export const ReplaceMakeSupplier = ({ state }: ReplaceMakeSupplierProps): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const history = useHistory()

  const queryParams = sessionStorage.getItem('SUPPLIERPARAMS') ? JSON.parse(sessionStorage.getItem('SUPPLIERPARAMS')!) : null

  const [data, setData] = useState<any>()

  const [total, setTotal] = useState<any>()

  const [params, setParams] = useState<TenantQueryParams>({
    size: 10,
    // current: location?.state?.current || 1,
    current: queryParams?.current || 1,
  })

  useEffect(() => {
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])

  const SupplierStatus = [
    {
      value: '',
      label: '全部',
    },
    {
      value: 0,
      label: '正常',
    },
    {
      value: 1,
      label: '已注销',
    },
  ]

  const ReplaceMakeCategoriesType = [
    {
      value: '',
      label: '全部',
    },
    {
      value: '0',
      label: '中药',
    },
    {
      value: '1',
      label: '颗粒剂',
    },
  ]

  const [supplierId, setSupplierId] = useState('')

  const [isSupplierModalVisible, setIsSupplierModalVisible] = useState(false)

  useEffect(() => {
    form.setFieldsValue({ ...queryParams?.queryParams })
    dispatch(
      getReplaceMakeSupplierList({ ...params, ...queryParams?.queryParams })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
        sessionStorage.removeItem('SUPPLIERPARAMS')
      })
  }, [params])

  return (
    <Col className={styles.wrap}>
      <Col className={styles.contentWrap}>
        <Form
          form={form}
          autoComplete='off'
          initialValues={{}}
          onFinish={(values) => {
            setParams({
              ...params,
              ...values,
              current: 1,
            })
            // console.log(location.state)
          }}
        >
          <Row
            justify='space-between'
            align='middle'
            style={{ marginTop: 10, marginBottom: 20, width: '100%' }}
          >
            <Space>
              <Form.Item name='name' noStyle>
                <Input
                  allowClear
                  placeholder='请输入代煎饮片厂名称/助记码'
                  prefix={<SearchOutlined />}
                  style={{ width: '315px' }}
                  onChange={form.submit}
                />
              </Form.Item>
              <Form.Item name='decoctionType' noStyle>
                <Select
                  allowClear
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  placeholder='代煎类别'
                  onChange={form.submit}
                  style={{ width: '200px' }}
                >
                  {ReplaceMakeCategoriesType.map((c) => (
                    <Select.Option key={c.label} value={c.value}>
                      代煎类别-{c.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='status' noStyle>
                <Select
                  allowClear
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  placeholder='饮片厂状态'
                  onChange={form.submit}
                  style={{ width: '200px' }}
                >
                  {SupplierStatus.map((c) => (
                    <Select.Option key={c.label} value={c.value}>
                      饮片厂状态-{c.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Space>
            <Space>
            <Button type='primary' onClick={form.submit}>
              查询
            </Button>
              <Button type='primary' onClick={() => setIsSupplierModalVisible(true)}>
                新增代煎饮片厂
              </Button>
            </Space>
          </Row>
        </Form>
        <EditableList
          page={{
            items: data,
            current: params.current || 1,
            size: params.size || 10,
            total,
          }}
          style={{ color: theme.tc3 }}
          className={styles.table}
          columns={columns(
            (action, t) => {
              switch (action) {
                case 'toggle':
                  dispatch(isOpenReplaceMakeSupplier(t.id))
                    .then(unwrapResult)
                    .then(() => {
                      dispatch(getReplaceMakeSupplierList({ ...params }))
                        .then(unwrapResult)
                        .then((res: any) => {
                          setData(res.records)
                          setTotal(res.total)
                        })
                    })
                  break
                case 'partner':
                  sessionStorage.setItem(
                    'SUPPLIERPARAMS',
                    JSON.stringify({
                      current: params.current,
                      queryParams: form.getFieldsValue(),
                    })
                  )
                  history.push({
                    pathname: '/admin/replaceMakeCenter/SupplierPartner',
                    state: {
                      id: t.id,
                      supplierName: t.name,
                    },
                  })
                  break;
                case 'herbs':
                  sessionStorage.setItem(
                    'SUPPLIERPARAMS',
                    JSON.stringify({
                      current: params.current,
                      queryParams: form.getFieldsValue(),
                    })
                  )
                  history.push({
                    pathname: '/admin/replaceMakeCenter/HerbsDirectory',
                    state: {
                      supplierId: t.id,
                      status: 1
                    },
                  })
                  break;
              }
            },
            (params.size || 10) * ((params.current || 1) - 1),
            theme
          )}
          onChangePage={(current: number, size?: number) => {
            setParams({
              ...params,
              current: current,
              size: size || 10,
            })
          }}
          onRow={(t) => ({
            onDoubleClick: () => {
              setSupplierId(t.id)
              setIsSupplierModalVisible(true)
            },
          })}
        />
      </Col>
      <AddReplaceMakeSupplierModel
        tenantId={supplierId}
        visible={isSupplierModalVisible}
        onCancel={() => {
          setSupplierId('')
          setIsSupplierModalVisible(false)
        }}
        onOk={() => {
          setSupplierId('')
          setIsSupplierModalVisible(false)
          dispatch(getReplaceMakeSupplierList({ ...params }))
            .then(unwrapResult)
            .then((res: any) => {
              setData(res.records)
              setTotal(res.total)
            })
        }}
      />
    </Col>
  )
}
